import { parseGroupDoc } from '@db/Groups/Common';
import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { Group } from '@types';

export function listenToGroup(
  groupId: string,
  onGroup: (group: Group) => void,
  onError: (error: db.FirestoreError) => void
) {
  const onNext = (doc: db.DocumentSnapshot) => {
    if (doc.exists()) {
      const groupDoc = parseGroupDoc(doc);
      onGroup(groupDoc);
    }
  };
  return db.onSnapshot(db.doc(firestore, 'groups', groupId), onNext, onError);
}
